"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class UsersResource {
    constructor(cloudConvert) {
        this.cloudConvert = cloudConvert;
    }
    me() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cloudConvert.axios.get('users/me');
            return response.data.data;
        });
    }
    subscribeJobEvent(id, event, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            this.cloudConvert.subscribe(`private-user.${id}.jobs`, `job.${event}`, callback);
        });
    }
    subscribeTaskEvent(id, event, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            this.cloudConvert.subscribe(`private-user.${id}.tasks`, `task.${event}`, callback);
        });
    }
}
exports.default = UsersResource;
//# sourceMappingURL=UsersResource.js.map